import { FormattedMessage } from 'react-intl';
import { Button } from '../../../../common/Button';
import Modal from '../../../../common/Modal';
import fixelIcon from '../../../../../../assets/icons/devices-router/fixel-unamused.svg';
import styles from './RouterDontLeaveModal.scss';

interface RouterDontLeaveModalProps {
  onClose: () => void;
  onLeave: () => void;
  isOpen?: boolean;
}

const RouterDontLeaveModal = ({ isOpen = false, onClose, onLeave }: RouterDontLeaveModalProps) => (
  <Modal isOpen={isOpen} className={styles.modal} onClose={onClose}>
    <img src={fixelIcon} width="136" height="162" alt="" className={styles.fixel} />

    <h1 className={styles.title}>
      <FormattedMessage
        id="profile.routerSection.dontLeaveModal.title"
        defaultMessage="Are you sure you want to leave the page?"
      />
    </h1>

    <p className={styles.text}>
      <FormattedMessage
        id="profile.routerSection.dontLeaveModal.text"
        defaultMessage="If you don’t download the configuration file before leaving the page, your settings won’t be saved, and you’ll need to start over"
      />
    </p>

    <div className={styles.buttonGroup}>
      <Button onClick={onLeave}>
        <FormattedMessage id="profile.routerSection.dontLeaveModal.leaveButton" defaultMessage="Leave" />
      </Button>
      <Button kind="primary" onClick={onClose}>
        <FormattedMessage id="profile.routerSection.dontLeaveModal.cancelButton" defaultMessage="Cancel " />
      </Button>
    </div>
  </Modal>
);

export default RouterDontLeaveModal;
